module.exports = __webpack_public_path__ + "img/fotos_3.5ccd27b5.jpg";